<greco-alert *ngIf="alert$ | async as alert" [config]="alert"></greco-alert>
